import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import SwiperCore, { Navigation } from "swiper";

const KeywordsSlider = ({
  languageSelected
}) => {
  const [] = useState([]);
  SwiperCore.use([Navigation]);
  const navprevRef = React.useRef(null);
  const navnextRef = React.useRef(null);

  return (
    <Swiper
      slidesPerView={'auto'}
      spaceBetween={10}
      navigation={{
        prevEl: navprevRef.current,
        nextEl: navnextRef.current,
      }}
      onBeforeInit={(swiper) => {
        swiper.params.navigation.prevEl = navprevRef.current;
        swiper.params.navigation.nextEl = navnextRef.current;
      }}
      className='keyword-slider'
    >
      {
        languageSelected?.map((item) => {
          return (
            <SwiperSlide key={item?.id}>
              <button
                className='btn btn-outline-default btn-sm rounded-3'
                key={item?.id}
                // onClick={() => handleKeywordSelect(item)}
              >{item?.value}</button>
            </SwiperSlide>
          )
        })
      }

      {/* <SwiperSlide >
        <button className='btn btn-outline-default btn-sm rounded-3'>dogging</button>
      </SwiperSlide>
      <SwiperSlide >
        <button className='btn btn-outline-default btn-sm rounded-3'>doggy style</button>
      </SwiperSlide>
      <SwiperSlide >
        <button className='btn btn-outline-default btn-sm rounded-3'>humping</button>
      </SwiperSlide>
      <SwiperSlide >
        <button className='btn btn-outline-default btn-sm rounded-3'>abduction</button>
      </SwiperSlide>
      <SwiperSlide >
        <button className='btn btn-outline-default btn-sm rounded-3'>adult</button>
      </SwiperSlide>
      <SwiperSlide >
        <button className='btn btn-outline-default btn-sm rounded-3'>anal</button>
      </SwiperSlide>
      <SwiperSlide >
        <button className='btn btn-outline-default btn-sm rounded-3'>arson</button>
      </SwiperSlide>
      <SwiperSlide >
        <button className='btn btn-outline-default btn-sm rounded-3'>assassination</button>
      </SwiperSlide>
      <SwiperSlide >
        <button className='btn btn-outline-default btn-sm rounded-3'>dogging</button>
      </SwiperSlide>
      <SwiperSlide >
        <button className='btn btn-outline-default btn-sm rounded-3'>bareback</button>
      </SwiperSlide>
      <SwiperSlide >
        <button className='btn btn-outline-default btn-sm rounded-3'>BBW</button>
      </SwiperSlide>
      <SwiperSlide >
        <button className='btn btn-outline-default btn-sm rounded-3'>bet</button>
      </SwiperSlide>
      <SwiperSlide >
        <button className='btn btn-outline-default btn-sm rounded-3'>big ass</button>
      </SwiperSlide>
      <SwiperSlide >
        <button className='btn btn-outline-default btn-sm rounded-3'>big dick</button>
      </SwiperSlide>
      <SwiperSlide >
        <button className='btn btn-outline-default btn-sm rounded-3'>big tits</button>
      </SwiperSlide>
      <SwiperSlide >
        <button className='btn btn-outline-default btn-sm rounded-3'>bitch</button>
      </SwiperSlide>
      <SwiperSlide >
        <button className='btn btn-outline-default btn-sm rounded-3'>bloody</button>
      </SwiperSlide> */}

      <div ref={navprevRef} className="slider-nav nav-prev">
        <i className="icon-arrow-left text-blue-900 fs-5"></i>
      </div>
      <div ref={navnextRef} className="slider-nav nav-next">
        <i className="icon-arrow-right text-blue-900 fs-5"></i>
      </div>
    </Swiper>
  )
}

export default KeywordsSlider